import styled from 'styled-components';

interface Props {
  color?: string;
}

const Description = styled.p<Props>`
  align-items: center;
  color: ${({ color }) => color || '#484C7A'};
  display: flex;
  flex-direction: column;
  font-family: "Inter UI";
  font-size: 15px;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  margin: 16px 0px;
  text-align: center;
`;

export default Description;
